import { render, staticRenderFns } from "./HAK.vue?vue&type=template&id=20ac7c8b"
import script from "./HAK.vue?vue&type=script&lang=js"
export * from "./HAK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports